import { Component } from '@angular/core';
import { CmsComponent } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { map, Observable } from 'rxjs';

export interface GgSimplePromoBannerComponent {
  uid: string;
  link: CmsComponent;
}

@Component({
  selector: 'app-gg-simple-promo-banner',
  templateUrl: 'gg-simple-promo-banner.component.html',
  standalone: false,
})
export class GgSimplePromoBannerComponent {
  data$: Observable<GgSimplePromoBannerComponent> = this.componentData.data$;

  constructor(private componentData: CmsComponentData<GgSimplePromoBannerComponent>) {}

  link$ = this.componentData.data$.pipe(map((data) => data?.link));
}
